import { PublicProfileStatusEnum, PublicProfileTypeEnum } from '@onArte/shared/database/enums';
import { ExternalAttachmentInterface, UploadedAttachmentInterface } from '@onArte/shared/interfaces/common';
import { SearchableDTOInterface } from '@onArte/shared/interfaces/website/search';
import { PublicProfileVersionModel } from '@onArte/shared/models';

export class PublicProfileModel implements SearchableDTOInterface {
  public id: string;
  public type: PublicProfileTypeEnum;
  public status: PublicProfileStatusEnum;
  public name: string;
  public relationId: string;
  public ownerId?: string;
  public description: string;
  public bio: string;
  public attachments: (ExternalAttachmentInterface|UploadedAttachmentInterface)[];
  public hasChangesToVerified: boolean;
  public createdAtTimestamp: number;
  public versions: PublicProfileVersionModel[];
  public blogPosts: number[];
}
